export default "__VITE_ASSET__87041d73__"